module.exports = __webpack_public_path__ + "static/proszek_sloik@0,75x-e099f3248dc5e85ce81c6d09447950ca.png";